import qs from 'qs';
import instance, { PPR_API_URL } from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IEquipment } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getEquipmentList = (params: IDynamicTableParams) => {
  return instance(true, PPR_API_URL)
    .get<IEquipment[]>('/dictionary/equipment/list', {
      params,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
    })
    .then((response) => response.data);
};

export const getEquipmentListAll = () => {
  return instance(true, PPR_API_URL)
    .get<IEquipment[]>('/dictionary/equipment/listAll')
    .then((response) => response.data);
};

export const getEquipmentListByEquipmentType = (equipmentTypeId: string) => {
  return instance(true, PPR_API_URL)
    .get<IEquipment[]>('/dictionary/equipment/list/' + equipmentTypeId)
    .then((response) => response.data);
};

export const getEquipmentAvailableColumns = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableColumnModel[]>('/dictionary/equipment/availableColumns')
    .then((response) => response.data);
};

export const getEquipmentAvailableGroupColumns = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableGroupColumnModel[]>('/dictionary/equipment/availableGroupColumns')
    .then((response) => response.data);
};
